import React, { FC } from 'react';
import {
  Checkbox,
  ListItemText,
  ListItem,
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    item: {
      paddingLeft: 140,
      paddingTop: 0,
      paddingBottom: 0,
    },
  }),
);

interface Params {
  id: number | string;
  checked: boolean;
  text: string;
  handleChange(
    event: React.ChangeEvent<HTMLInputElement>,
    id: number | string,
  ): void;
  disabled?: boolean;
}

const CheckBoxListItem: FC<Params> = (props) => {
  const { checked, text, handleChange, id, disabled } = props;
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleChange(event, id);
  };

  const classes = useStyles();

  return (
    <ListItem className={classes.item}>
      <Checkbox checked={checked} onChange={onChange} disabled={disabled} />
      <ListItemText
        primary={text}
        primaryTypographyProps={{
          style: { color: disabled ? 'grey' : undefined },
        }}
      />
    </ListItem>
  );
};

export default CheckBoxListItem;
